import { bannerGenerator } from './banners'
import { productsListGenerator } from './productsList'

export const GtmDataAttributesGenerator = {
  banner: bannerGenerator,
  productsList: productsListGenerator
}
